import { Checkbox, SelectionStatus, TextField } from '@symphony-ui/uitoolkit-components';
import Variation from '../../../../../../models/data/Variation';
import * as React from 'react';
import { floatRegex } from '../../regexes';
import LabelPlacements from '@symphony-ui/uitoolkit-components/components/selection/LabelPlacements';
const VariationEditor = ({ value, onChange }) => {
    const [val, setVal] = React.useState(value?.value.toString() ?? '');
    const [wpir, setWpir] = React.useState(value?.suffix === 'WPIR');
    const onChangeVal = React.useCallback((event) => {
        const newText = event.target.value;
        if (floatRegex.exec(newText)) {
            setVal(newText);
            if (newText !== '') {
                const newValue = Number.parseFloat(newText);
                const updated = value !== undefined ? value.updateValue(newValue) : new Variation({ value: newValue });
                onChange({ target: { value: updated } });
            }
            else {
                onChange({ target: { value: undefined } });
            }
        }
    }, [onChange, value]);
    const onChangeSuffix = React.useCallback(() => {
        const updated = value !== undefined ? value.updateSuffix(!wpir ? 'WPIR' : undefined) : new Variation({ value: 0, suffix: !wpir ? 'WPIR' : undefined });
        onChange({ target: { value: updated } });
        setWpir(current => !current);
    }, [wpir, onChange, value]);
    const disabled = React.useMemo(() => {
        return val === '';
    }, [val]);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { fontSize: 'x-large', alignSelf: 'end', marginBottom: '0.25rem', marginRight: '0.25rem' } }, "\u00B1"),
        React.createElement("div", { style: { width: '4rem' } },
            React.createElement(TextField, { label: "Value", value: val, onChange: onChangeVal })),
        React.createElement("div", { className: 'co-checkbox-compact' },
            React.createElement(Checkbox, { disabled: disabled, label: "WPIR", labelPlacement: LabelPlacements.TOP, name: "wpir", onChange: onChangeSuffix, status: wpir ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: "" }))));
};
export default VariationEditor;
